// extracted by mini-css-extract-plugin
export default {"container":"Error-module_container_ov9chd"};